import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ReportIcon = ({
  width = 48,
  color = 'foraBlue',
  marginRight,
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <path id="prefix__a" d="M0 0.148L46.013 0.148 46.013 59.306 0 59.306z" />
        <path id="prefix__c" d="M0 65.733L46.013 65.733 46.013 0 0 0z" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(16.557 6.5)">
        <g transform="translate(0 6.426)">
          <path
            fill={getSemanticTextColor(color)}
            d="M35.058 48.095h6.83L34.8 55.183V48.35c0-.142.116-.256.258-.256M43.303.148H33.52v1.111c.609.04 1.095.535 1.095 1.155v1.02h7.016c.603 0 1.094.49 1.094 1.095v41.89h-7.668c-1.067 0-1.934.868-1.934 1.932v7.67H4.382c-.606 0-1.097-.49-1.097-1.096V4.529c0-.605.491-1.094 1.097-1.094h6.965V2.414c0-.62.486-1.115 1.095-1.155V.148H2.71C1.214.148 0 1.361 0 2.858v53.738c0 1.498 1.213 2.71 2.71 2.71h40.592c1.496 0 2.71-1.212 2.71-2.71V2.858c0-1.497-1.214-2.71-2.71-2.71"
          />
        </g>
        <path
          fill={getSemanticTextColor(color)}
          d="M23.007 4.382h-.005c-.602-.003-1.091-.493-1.091-1.095 0-.605.489-1.092 1.09-1.096h.006c.603 0 1.094.49 1.094 1.096 0 .605-.49 1.095-1.094 1.095m8.764 3.303v-1.11c0-1.211-.98-2.193-2.19-2.193h-3.288V3.287c0-1.815-1.471-3.286-3.286-3.286h-.005c-1.814.003-3.282 1.473-3.282 3.286v1.095h-3.287c-1.211 0-2.19.982-2.19 2.192v1.111c-.612.04-1.096.535-1.096 1.155v2.792c0 .65.524 1.172 1.171 1.172h17.377c.646 0 1.172-.523 1.172-1.172V8.84c0-.62-.486-1.114-1.096-1.155"
        />
        <path
          fill={getSemanticTextColor(color)}
          d="M16.885 32.274h1.877v3.704h.025c.187-.323.384-.622.584-.92l1.889-2.784h2.338l-2.772 3.567 2.908 4.81h-2.201l-2.062-3.617-.709.882v2.735h-1.877v-8.377zM26.401 35.99h.745c.947 0 1.505-.472 1.505-1.206 0-.757-.523-1.154-1.391-1.154-.461 0-.723.023-.859.062v2.297zm-1.877-3.592c.609-.113 1.504-.186 2.524-.186 1.242 0 2.112.186 2.709.67.51.399.784.982.784 1.753 0 1.056-.759 1.79-1.48 2.052v.035c.585.238.907.784 1.118 1.555.262.957.511 2.052.67 2.374h-1.937c-.124-.249-.335-.92-.573-1.951-.235-1.058-.595-1.331-1.378-1.343h-.56v3.294h-1.877v-8.253z"
        />
        <path
          fill={getSemanticTextColor(color)}
          d="M24.102 22.223L38.118 22.223 38.118 18.13 24.102 18.13zM7.308 56.371L21.324 56.371 21.324 52.276 7.308 52.276z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
